/**
 * @param {object} statistics - statistics object
 * @param {string} dataSourceId - id of data source
 */
export const getCountPhotos = (statistics, dataSourceId) => {
  return (
    (statistics &&
      statistics.overall &&
      statistics.overall.origins &&
      Object.values(statistics.overall.origins).reduce(
        (currentState, { dataSources }) => {
          const partialUniquePhotos =
            dataSources &&
            dataSources[dataSourceId] &&
            dataSources[dataSourceId]['vinne_annotation'] &&
            dataSources[dataSourceId]['vinne_annotation'].categories &&
            Object.values(
              dataSources[dataSourceId]['vinne_annotation'].categories
            ).reduce((currentState, { tags }) => {
              const partialUniquePhotos =
                tags &&
                Object.values(tags).reduce((currentState, { photos }) => {
                  const partialUniquePhotos =
                    photos &&
                    Object.values(photos).reduce((currentState, photos) => {
                      return currentState
                        .concat(photos)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );
                    }, []);
                  if (partialUniquePhotos && partialUniquePhotos.length > 0)
                    return currentState
                      .concat(partialUniquePhotos)
                      .filter(
                        (photo, index, photos) =>
                          photos.indexOf(photo) === index
                      );
                  return currentState;
                }, []);
              if (partialUniquePhotos && partialUniquePhotos.length > 0)
                return currentState
                  .concat(partialUniquePhotos)
                  .filter(
                    (photo, index, photos) => photos.indexOf(photo) === index
                  );
              return currentState;
            }, []);
          if (partialUniquePhotos && partialUniquePhotos.length > 0)
            return currentState
              .concat(partialUniquePhotos)
              .filter(
                (photo, index, photos) => photos.indexOf(photo) === index
              );
          return currentState;
        },
        []
      )) ||
    []
  );
};
